module.exports = __webpack_public_path__ + "static/media/Monday_Step2_Image7.4bf9dc53.webp";